export default "__VITE_ASSET__DksppJs4__"